import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from '../../styles.scss'
import Viewer from './components/Viewer'

class Feed extends Component {
    // Initialize the constructor and set the
    // original state of the class
    constructor(props) {
        super(props)

        this.state = {
            activeAd: 0,
            paused: false,
            timer: 0,
        }

        this.timerInterval = undefined
        this.timestamp = 0
    }

    componentDidMount() {
        this.timer()
    }

    componentWillUnmount() {
        // Clear the interval timer for for the ad rotation
        clearInterval(this.timerInterval)
    }

    timer = () => {
        // Start a timer for rotating ads automatically
        this.timerInterval = setInterval(() => {
            // If the user hovers over the ad
            // we pause the timer
            if (!this.state.paused) {
                // Increment the timer
                this.setState(prevState => ({
                    timer: prevState.timer + 1,
                }))
            }

            // Once the timer reaches a certain point we
            // switch ads and reset the timer
            if (this.state.timer >= this.props.displaySeconds) {
                this.next()
            }
        }, 1000)
    }

    pause = (paused) => {
        // Pause the ad rotation timer
        this.setState({ paused })
    }

    next = () => {
        // Retrieve the campaigns from state
        const campaigns = this.props.creatives

        // If campaigns are available we enter continue
        // to increment the value
        if (campaigns !== undefined && campaigns.length > 0) {
            // Retrieve currently active ad number
            // and increment it by one
            let active = this.state.activeAd + 1

            // If the active number has exceeded or is equal
            // to the number of ads in the campaign
            // we reset the counter to zero
            if (active >= campaigns.length) {
                active = 0
            }

            // Update the state
            this.setState({ activeAd: active, timer: 0 })
        }
    }

    previous = () => {
        const campaigns = this.props.creatives

        if (campaigns !== undefined && campaigns.length > 0) {
            // Retrieve currently active ad number
            // and reduce it by one
            let active = this.state.activeAd - 1

            // If active has dipped below zero we go to the last
            // item in the campaigns
            if (active < 0) {
                active = campaigns.length - 1
            }

            // Update the state
            this.setState({ activeAd: active, timer: 0 })
        }
    }

    renderAds = () => {
        const config = {
            activeAd: this.state.activeAd,
            campaigns: this.props.creatives,
            onClick: this.props.onAdClick,
        }
        return <Viewer {...config} />
    }

    renderControls = () => {
        if (this.props.creatives.length < 2) return null

        return (
            <div className={styles.controls}>
                <i
                    aria-hidden
                    className="prev flaticon-arrow-left"
                    onClick={() => this.previous()}
                />
                <i aria-hidden className="prev flaticon-arrow-right" onClick={() => this.next()} />
            </div>
        )
    }

    render() {
        try {
            const controls = this.renderControls()
            const ads = this.renderAds()

            return (
                <div
                    className={styles.creatives}
                    onMouseOver={() => this.pause(true)}
                    onMouseOut={() => this.pause(false)}
                >
                    {controls}
                    {ads}
                </div>
            )
        } catch (error) {
            console.info(`Encountered an error while rendering ad-manager: ${error.message}`)
        }
    }
}

Feed.propTypes = {
    // fetching: PropTypes.bool,
    creatives: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            src: PropTypes.string,
            link: PropTypes.string,
        }),
    ),
    onAdClick: PropTypes.func,
    displaySeconds: PropTypes.number,
}

export default Feed



// WEBPACK FOOTER //
// ./src/features/Creatives/components/Feed/component.js